import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import Logger from './Logger';

function get(_name) {
  var cookies = decodeURIComponent(document.cookie).split(';').map(function (cookie) {
    var _cookie$split = cookie.split('='),
        _cookie$split2 = _slicedToArray(_cookie$split, 2),
        name = _cookie$split2[0],
        value = _cookie$split2[1];

    return {
      name: name.trim(),
      value: value
    };
  });
  return cookies.find(function (cookie) {
    return cookie.name === _name.trim();
  });
}

function getAll() {
  return decodeURIComponent(document.cookie).split(';').reduce(function (result, cookie) {
    var _cookie$split3 = cookie.split('='),
        _cookie$split4 = _slicedToArray(_cookie$split3, 2),
        name = _cookie$split4[0],
        value = _cookie$split4[1];

    return _extends({}, result, _defineProperty({}, name.trim(), value));
  }, {});
}

function exists(name) {
  return !!get(name);
}

function set(name, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!name || name.replace(/ /gi, '') === '') {
    Logger.error('Cookie name cannot be empty, null or undefined');
    return;
  }

  var _options = _extends({}, options, {
    path: options.path || '/'
  });

  var setCookieParams = function setCookieParams() {
    return Object.entries(_options).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          val = _ref2[1];

      return "".concat(key, "=").concat(val, ";");
    }).join('');
  };

  document.cookie = "".concat(name, "=").concat(value, ";").concat(setCookieParams());
}

function remove(name) {
  set(name, '', {
    expires: new Date(0).toUTCString()
  });
}

export { exists, get, getAll, remove, set };